<template>
  <div>
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
        <form>
          <!-- <div class="p-grid">
            <div class="p-col">
              <Button class="p-button-raised p-button-rounded" @click.prevent="openAddDialog"
               icon="pi pi-plus" style="float:right;"/>
            </div>
          </div> -->
          <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW"/>
          </div>
        </div>
          <Dialogs  header="Company"  :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
          :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="name" >Name<span style="color:red">*</span></label>
                <InputText id="name" v-model.trim="name"/>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="companyBusinessType" >Business Type<span style="color:red">*</span></label>
                <InputText id="companyBusinessType" v-model.trim="companyBusinessType"/>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="companyDomain" >Domain Name<span style="color:red">*</span></label>
                <InputText id="companyDomain" v-model.trim="companyDomain"/>
              </div>
              
              <div class="p-field p-col-12 p-md-6">
                <label for="contactNum" >Contact Number</label>
                <InputText @keypress="isNumber($event)" v-model="contactNumber" id="contactNum"/>
              </div>

              <div class="p-field p-col-12 p-md-6">
                <label for="email" >Email</label>
                <InputText v-model.trim="email" id="email"/>
              </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="address" >Address</label>
              <InputText v-model.trim="address" id="address"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="numberOfEmployee" >No of employee</label>
              <InputText @keypress="isNumber($event)" v-model.number="numberOfEmployee" id="numberOfEmployee"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <label for="annualRevenue" >Annual Revenue</label>
            <InputText type="text"  v-model.trim="annualRevenue" id="annualRevenue"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label for="conDescription">Description</label>
                <Textarea id="conDescription" rows="3" class="form-control" v-model="description"/>
              </div>

      </div>
      <template #footer>
        <Button class="p-button-raised p-button" @click.prevent="addCompany" :label="editing?'Update':'Add'"/>
        <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewComany" v-if="!editing"/>
        <Button  @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
      </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import Textarea from 'primevue/textarea/Textarea'
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
export default {
  name: 'supplier',
  data() {
    return {
      name: '',
      companyDomain: '',
      address: '',
      contactNumber: '',
      companyBusinessType: '',
      email: '',
      numberOfEmployee: '',
      annualRevenue: '',
      description: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      createUser: false,
      status: 'ACTIVE',
      id: '',
      loading: false,
      columnList: '',
      filters: {}
    }
  },
  methods: {
    async addCompany() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.companyDomain === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'company Domain cannot be empty!', life: 10000})
        return
      }
      if (this.companyBusinessType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Business Type cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let company = {
        id: this.id,
        companyName: this.name,
        companyDomain: this.companyDomain,
        address: this.address,
        contactNumber: this.contactNumber,
        businessTypeName: this.companyBusinessType,
        email: this.email,
        numberOfEmployee: this.numberOfEmployee,
        annualRevenue: this.annualRevenue,
        description: this.description
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmCompany', company)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmCompany', company)
        console.log(resp)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewComany() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
        return
      }
      if (this.companyDomain === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'company Domain cannot be empty!', life: 10000})
        return
      }
      if (this.companyBusinessType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Business Type cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        companyName: this.name,
        companyDomain: this.companyDomain,
        address: this.address,
        contactNumber: this.contactNumber,
        businessTypeName: this.companyBusinessType,
        email: this.email,
        numberOfEmployee: this.numberOfEmployee,
        annualRevenue: this.annualRevenue,
        description: this.description
      }
      console.log(accountMaster)
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmCompany', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editCompany(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.name = data.companyName
      this.companyDomain = data.companyDomain
      this.address = data.address
      this.annualRevenue = data.annualRevenue
      this.description = data.description
      this.contactNumber = data.contactNumber
      this.companyBusinessType = data.businessTypeName
      this.email = data.email
      this.numberOfEmployee = data.numberOfEmployee
      // if (this.openingBalance > 0) {
      //   this.openingDrCr = 'Cr'
      // } else {
      //   this.openingDrCr = 'Dr'
      // }
      if (this.status === undefined) {
        this.status = 'INACTIVE'
      }
      this.openAddDialog()
    },
    reset() {
      this.name = ''
      this.companyDomain = ''
      this.address = ''
      this.contactNumber = ''
      this.companyBusinessType = ''
      this.email = ''
      this.numberOfEmployee = ''
      this.status = ''
      this.annualRevenue = ''
      this.description = ''
      this.licenseExpireDate = ''
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.id = id
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmCompaniesDialog.vue?55c0816c